import constants from "../../constants";
import { isStoreHost, getPublicServerEndpoint, setResolvedSubdomain } from "../helper";

const isLocalNetwork = (host) => {
  return /^192\.168\.\d{1,3}\.\d{1,3}(:\d+)?$/.test(host) || host.startsWith("localhost");
};

const fetchSubdomainClientSide = async (host) => {
  const url = `${getPublicServerEndpoint({ host })}/v2/store/get-subdomain/${encodeURI(host)}`;
  console.log("Fetching subdomain for:", host, url);

  try {
    const response = await fetch(url, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
    });
    const data = await response.json();
    console.log("Fetched subdomain:", data.data.subdomain);
    return data.data.subdomain;
  } catch (err) {
    console.error("fetchSubdomain ERROR:", err);
    throw err;
  }
};

const fetchRecordClientSide = async (subdomain) => {
  try {
    let recordMeta = {};
    const url = `${getPublicServerEndpoint({ subdomain })}/v4/store/get-by-subdomain/${subdomain}?select=internationalPayment,proplan,legalInfo`;

    try {
      const response = await fetch(url);
      recordMeta = await response.json();
      recordMeta = recordMeta.data;
    } catch (err) {
      console.error("getRecord ERROR: ", err);
      console.log({ err });
      throw err;
    }

    if (!recordMeta) {
      return;
    }

    //TODO: /by-store/:storeId
    let productData = {};

    recordMeta.Products = productData;

    return recordMeta;
  } catch (err) {
    console.log("error in getrecord api " + err);
    throw err;
  }
};

export const fetchThemeDataFromSubdomain = async (subdomain) => {
  if (!subdomain) return null;

  try {
    const url = `${getPublicServerEndpoint({ subdomain })}/v5/theme/${subdomain}`;

    const response = await fetch(url);
    const themeData = await response.json();

    if (themeData.message === "Not found") {
      return null;
    }

    return themeData;
  } catch (err) {
    console.error("fetchThemeDataFromSubdomain ERROR: ", err);
    return null;
  }
};

export const getStoreClientSide = async () => {
  const host = window.location.host;
  const splitHost = host.split(".");
  let subdomain = isLocalNetwork(host) ? constants.devEnv.storeSubdomain : splitHost[0];
  const hostWithProtocol = isLocalNetwork(host) ? `http://${host}` : `https://${host}`;

  // Handle custom domains
  if (!isStoreHost(host) && !isLocalNetwork(host)) {
    subdomain = await fetchSubdomainClientSide(host);
    console.log("🚀 ~ getStoreClientSide ~ subdomain after:", subdomain);
  }

  setResolvedSubdomain(subdomain);

  const [store, themeData] = await Promise.all([
    fetchRecordClientSide(subdomain),
    fetchThemeDataFromSubdomain(subdomain),
  ]);

  const storeUrl = `${hostWithProtocol}/`;
  const errorCode = false;

  if (!store) {
    return {
      storeData: null,
      error: 404,
      storeUrl: storeUrl,
      themeData: null,
    };
  }

  return {
    storeData: store,
    error: errorCode,
    storeUrl,
    themeData,
  };
};

export const getProductClientSide = async (productId, subdomain) => {
  try {
    const url = `${getPublicServerEndpoint({ subdomain })}/v4/product/${productId}`;
    const res = await fetch(url);
    const jsonRes = await res.json();

    if (jsonRes.error || !jsonRes.data) {
      console.log("Error get from getProductClientSide...");
      throw new Error("Product not found");
    }

    const product = jsonRes.data;

    const host = window.location.host;
    const hostWithProtocol = isLocalNetwork(host) ? `http://${host}` : `https://${host}`;
    const productUrl = `${hostWithProtocol}/product/${productId}`;

    return {
      product,
      productId,
      productUrl,
      errorCode: false,
    };
  } catch (err) {
    console.error("getProductClientSide ERROR: ", err);

    return {
      product: null,
      productId,
      productUrl: "",
      errorCode: 404,
    };
  }
};
